import { createStyles } from 'antd-style'

import { RouterOutlet } from '@eastcoal/router/components/Outlet'
import { EastcoalLogo } from '@eastcoal/shared/components/EastcoalLogo'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexFlow: 'row nowrap',
    padding: token.paddingXL,
    height: '100vh'
  },
  sider: {
    flex: '0 0 300px',
    borderRight: `${token.lineWidth}px ${token.lineType} ${token.colorBorder}`
  },
  content: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

export const UserLayout = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <div className={styles.sider}>
        <EastcoalLogo />
      </div>
      <div className={styles.content}>
        <RouterOutlet />
      </div>
    </div>
  )
}
